import { render, staticRenderFns } from "./OverlayComponent.vue?vue&type=template&id=760bf33f&scoped=true&"
import script from "./OverlayComponent.vue?vue&type=script&lang=js&"
export * from "./OverlayComponent.vue?vue&type=script&lang=js&"
import style0 from "./OverlayComponent.vue?vue&type=style&index=0&id=760bf33f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760bf33f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760bf33f')) {
      api.createRecord('760bf33f', component.options)
    } else {
      api.reload('760bf33f', component.options)
    }
    module.hot.accept("./OverlayComponent.vue?vue&type=template&id=760bf33f&scoped=true&", function () {
      api.rerender('760bf33f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/OverlayComponent.vue"
export default component.exports